'use client';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Badge, Button } from '@ui';
import { motion } from 'framer-motion';

export default function ModulesGrid({ modules }) {
    return (
        <>
            {modules.map(({ title, description, link, icon, variant, highlights }, index) => {
                return (
                    <motion.article
                        key={title}
                        whileInView={{ opacity: 1 }}
                        initial={{ opacity: 1 }}
                        viewport={{ once: true, amount: 0.2 }}
                        transition={{
                            opacity: { duration: 0.2, ease: 'easeOut' },
                            delay: index * 0.06
                        }}
                        className="tw-group tw-relative tw-isolate tw-overflow-hidden tw-rounded-3xl tw-border tw-border-solid tw-border-accents-2 tw-bg-gradient-to-br tw-from-accents-5/25 tw-via-white tw-to-success/25 tw-transition-all tw-duration-200"
                    >
                        <div
                            aria-hidden
                            className="tw-pointer-events-none tw-absolute tw-inset-0 tw-z-0 tw-bg-gradient-to-br tw-from-success/0 tw-via-success/5 tw-to-success/60 tw-opacity-0 tw-transition-opacity tw-duration-300 group-hover:tw-opacity-100"
                        />

                        <div className="tw-relative tw-z-10 tw-flex tw-h-full tw-flex-col tw-gap-6 tw-px-4 tw-py-10 sm:tw-px-10">
                            <div className="tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-gap-4">
                                <div className="tw-flex tw-items-center tw-gap-4">
                                    <span className="tw-flex tw-h-12 tw-w-12 tw-items-center tw-justify-center tw-rounded-2xl tw-border tw-border-accents-5">
                                        <FontAwesomeIcon icon={icon} className="tw-text-2xl" />
                                    </span>
                                    <div>
                                        <h3 className="tw-text-left tw-text-xl tw-font-semibold md:tw-text-2xl lg:tw-text-3xl">
                                            {title}
                                        </h3>
                                    </div>
                                </div>
                            </div>

                            <p className="tw-text-left tw-text-base tw-text-accents-8">{description}</p>

                            {highlights?.length > 0 && (
                                <div className="tw-flex tw-flex-wrap tw-gap-2">
                                    {highlights.map((h, i) => (
                                        <Badge size="sm" key={i} color="success" flat>
                                            {h}
                                        </Badge>
                                    ))}
                                </div>
                            )}

                            <div className="tw-mt-auto tw-flex tw-items-center tw-justify-between">
                                <Button.Link size="sm" href={link}>
                                    Mehr erfahren
                                    <FontAwesomeIcon icon={faChevronRight} className="tw-text-xs" />
                                </Button.Link>

                                <span className="tw-text-right tw-text-xs tw-uppercase tw-tracking-[0.3em] tw-text-accents-8">
                                    {variant}
                                </span>
                            </div>
                        </div>

                        <div className="tw-pointer-events-none tw-absolute -tw-right-16 tw-top-1/2 tw-h-48 tw-w-48 -tw-translate-y-1/2 tw-rounded-full tw-bg-accents-5/10 tw-blur-3xl" />
                    </motion.article>
                );
            })}
        </>
    );
}
